export default __webpack_public_path__ + "9de78d61fd86f417b683b0a89bc66577.woff2";